import { styled, Box, Button, Typography } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const { PLAIN_TEXT, DARK_TEXT } = COLORS;

export const MainContainer = styled('div')(({ theme }) => ({
  margin: '30px 10px 30px',
}));

export const Top = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

export const MyPicCont = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? '#0a0b15' : '#fff',
  borderStyle: 'solid',
  borderWidth: '1px',
  borderImageSource: 'linear-gradient(253deg, #d51bff, #00d4ff)',
  backgroundImage: 'linear-gradient(to bottom, #0c0f14, #0c0f14), linear-gradient(253deg, #d51bff, #00d4ff)',
  backgroundOrigin: 'border-box',
  backgroundClip: 'content-box, border-box',
  borderRadius: '8px !important',
  display: 'flex',
  alignItems: 'center',
  width: 188,
  height: 188,
  margin: '0 auto 20px',
  justifyContent: 'center',
}));

export const MyPic = styled('img')(({ theme }) => ({
  width: 180,
  height: 180,
  objectFit: 'cover',
  objectPosition: 'top',
  borderRadius: 8,
}));

export const DashboardItemsContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 50%)',
  gap: 25,
  width: `calc(100% - 25px)`,
  margin: '30px 0',
}));

export const ActionButton = styled(Button)(({ theme }) => ({
  width: '100%',
  minHeight: 74,
  borderRadius: 8,
  border: theme.palette.type === 'dark' ? '1px solid #2d343e' : '1px solid #cdd9e9',
  display: 'flex',
  justifyContent: 'start',
  fontSize: 18,
  padding: '12px 30px 12px',
  textAlign: 'left',
  background:
    theme.palette.type === 'dark'
      ? 'linear-gradient(to bottom, #161c25, #0d1117)'
      : 'linear-gradient(to bottom, #fff, #fff)',

  '& svg': {
    height: 30,
    width: 'auto',
    marginRight: 10,

    '& path': {
      fill: COLORS.PRIMARY,
    },
  },
}));

export const ActionButtonTwoRowLabel = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  marginTop: -5,

  '& .MuiButton-label > div': {
    whiteSpace: 'normal',
  },
}));

export const FlexContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 25,
}));

// New Styled Component
export const TextSwitchColor = styled('p')(({ theme, size }: any) => ({
  color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
  fontSize: size || 16,
}));
